/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleStopGroup extends models.BillingRule {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleStopGroup");
    }

    getFixupPrototypeFunction() { return BillingRuleStopGroup.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleStopGroup>): BillingRuleStopGroup {
        let obj = Object.assign(new BillingRuleStopGroup(), model);
        BillingRuleStopGroup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleStopGroup>): BillingRuleStopGroup {
        if (!model) return null;
        return BillingRuleStopGroup.newInstance(<BillingRuleStopGroup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleStopGroup) {
        if (!obj) return;

        models.BillingRuleStopGroup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleStopGroup): boolean {
        if (models.BillingRule.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleStopGroup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
